app.directive('loadingBarTop', ['portalHelper', function (portalHelper) {
  return {
    templateUrl: portalHelper.getUrlRev('html_templates/directives/loading_bar_top.961185c8.html')
  };
}]);
